import React from 'react'
import BlankPage from '../../Component/TeamOverview/BlankPage'
const BlankPageMain = () => {
  return (
    <div className='page-body'>
      <BlankPage />
    </div>
  )
}

export default BlankPageMain